module.exports = __webpack_public_path__ + "4c88edddc81c88451fb0e6bc51ecd416.png";